import { render, staticRenderFns } from "./CustomNotification.vue?vue&type=template&id=3eb2664c&scoped=true&lang=pug"
import script from "./CustomNotification.vue?vue&type=script&lang=js"
export * from "./CustomNotification.vue?vue&type=script&lang=js"
import style0 from "./CustomNotification.vue?vue&type=style&index=0&id=3eb2664c&prod&lang=scss&scoped=true"
import style1 from "./CustomNotification.vue?vue&type=style&index=1&id=3eb2664c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3eb2664c",
  null
  
)

export default component.exports